import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAsset7 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 14.75V0.75H14.75V14.75H0.75ZM0.75 14.75V9.05232H6.46729M9.03271 6.44768V0.75M9.03271 6.44768H14.75M9.03271 6.44768L6.46729 9.05232M6.46729 9.05232V14.75",
		stroke: "#212121",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgAsset7;
